import { mainSiteUrl } from '@/mocks/categories';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Soft%20elegant%20contemporary%20fashion%20lifestyle%20flat%20lay%20with%20carefully%20arranged%20neutral%20toned%20apparel%20pieces%20accessories%20and%20shopping%20essentials%20on%20warm%20cream%20background%20clean%20minimalist%20aesthetic%20editorial%20composition%20with%20diffused%20natural%20lighting&width=1600&height=900&seq=hero-bg-v2-01&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background-50/70 via-background-50/40 to-background-50/90" />

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 bg-accent-100/80 text-accent-800 text-xs font-semibold px-4 py-1.5 rounded-full mb-6">
            <div className="w-2 h-2 bg-accent-500 rounded-full animate-pulse" />
            Updated Daily &middot; 2026 Edition
          </div>

          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight mb-6">
            Kakobuy Spreadsheet 2026 &mdash; Find The Best Products Faster
          </h1>

          <p className="text-base md:text-lg text-foreground-500 leading-relaxed mb-8 max-w-xl">
            Access curated product spreadsheets, quality-checked recommendations, category collections, and expert shopping guides &mdash; all in one place.
          </p>

          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3.5 rounded-full text-sm font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/20"
            >
              Explore Kakobuy Spreadsheet
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="flex items-center gap-2 bg-background-50 border border-background-300/70 hover:border-primary-400 px-8 py-3.5 rounded-full text-sm font-semibold text-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Visit Main Platform
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-sm"></i>
              </div>
            </a>
          </div>

          <div className="flex flex-wrap items-center gap-6 mt-8">
            <span className="flex items-center gap-1.5 text-xs text-foreground-400">
              <div className="w-4 h-4 flex items-center justify-center text-accent-500">
                <i className="ri-check-line text-sm"></i>
              </div>
              Updated Daily
            </span>
            <span className="flex items-center gap-1.5 text-xs text-foreground-400">
              <div className="w-4 h-4 flex items-center justify-center text-accent-500">
                <i className="ri-check-line text-sm"></i>
              </div>
              Organized Categories
            </span>
            <span className="flex items-center gap-1.5 text-xs text-foreground-400">
              <div className="w-4 h-4 flex items-center justify-center text-accent-500">
                <i className="ri-check-line text-sm"></i>
              </div>
              Beginner Friendly
            </span>
            <span className="flex items-center gap-1.5 text-xs text-foreground-400">
              <div className="w-4 h-4 flex items-center justify-center text-accent-500">
                <i className="ri-check-line text-sm"></i>
              </div>
              Shopping Research Tool
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}